var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1015_1333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19.644H19.71L19.43 19.374C20.4439 18.1981 21.0011 16.6967 21 15.144C21 13.8585 20.6188 12.6018 19.9046 11.5328C19.1903 10.4639 18.1752 9.6308 16.9874 9.13883C15.7997 8.64686 14.4928 8.51814 13.2319 8.76894C11.971 9.01975 10.8128 9.63881 9.90381 10.5479C8.99477 11.4569 8.3757 12.6151 8.1249 13.876C7.87409 15.1368 8.00282 16.4438 8.49479 17.6315C8.98676 18.8192 9.81988 19.8344 10.8888 20.5486C11.9577 21.2628 13.2144 21.644 14.5 21.644C16.11 21.644 17.59 21.054 18.73 20.074L19 20.354V21.144L24 26.134L25.49 24.644L20.5 19.644ZM14.5 19.644C12.01 19.644 10 17.634 10 15.144C10 12.654 12.01 10.644 14.5 10.644C16.99 10.644 19 12.654 19 15.144C19 17.634 16.99 19.644 14.5 19.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15.644H15V17.644H14V15.644H12V14.644H14V12.644H15V14.644H17V15.644Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1015_1333",
    x: 5.7,
    y: 6.34404,
    width: 22.0902,
    height: 22.0902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_1333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_1333",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.9ecea8833997a373bdc8ff4169fa7699.svg";
export { ForwardRef as ReactComponent };